<template>
  <div>
    <vxe-grid
      ref="grid"
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      row-id="shipmentCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="{ trigger: 'row', highlight: true, strict: false }"
      @radio-change="radioChange"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>

      <template #pager>
        <slot name="pager"></slot>
      </template>

      <template #displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>

      <template #displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>

      <template #empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import tableColumns from './table-columns'

export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => ({}) },
    tableHeight: { type: Number, default: 500 },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    radioChange({ newValue }) {
      this.$emit('choose-change', newValue)
    },
  },
}
</script>
